import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CtxIABCategory, CtxReadabilityLevel, CtxSentimentClass } from '../models';

import { OktaHttpReqService } from './okta-http-req.service';

@Injectable()
export class CtxFeatureGroupService {
  private endpoint = 'api/v1/contextual';

  constructor(private oktaHttpReqService: OktaHttpReqService) {}

  getReadabilityLevels(): Observable<CtxReadabilityLevel> {
    return this.oktaHttpReqService.request('get', `${this.endpoint}/readability`);
  }

  getSentimentClasses(): Observable<CtxSentimentClass> {
    return this.oktaHttpReqService.request('get', `${this.endpoint}/sentiment`);
  }

  getIABCategories(searchTerm: string): Observable<CtxIABCategory[]> {
    return this.oktaHttpReqService.request(
      'get',
      `${this.endpoint}/watson/iab-tiers?search=${encodeURIComponent(searchTerm)}` +
      `&include_slugs=true&order_by=tier`,
    );
  }
}
